import { PlusOutlined } from '@ant-design/icons';
import { Button, Descriptions, Drawer, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import Add from './Add';
import { useVariations } from './VarStore';
import Edit from './Edit';

function Variations({ vr }) {
    let [open, setOpen] = useState(false)
    let { variations, getVariations, setV, vcolumns, editOpen, setEditOpen, editV, setEditV } = useVariations()
    useEffect(() => {
        getVariations(vr.id)
        setV(vr)
    }, [vr])
    return (
        <div style={{ overflow: 'auto' }}>
           
            <Drawer open={editOpen} onClose={() => setEditOpen(false)} title='Tahrirlash' footer={null} width={'40%'}>
                <Edit />
            </Drawer>
            <Drawer width={'40%'} title='Variatsiyalar' open={open} onClose={() => setOpen(false)}>
                <Add vr={vr} />
            </Drawer>
            <Descriptions title={vr.nameuz + ' | ' + vr.brand + ' - ' + vr.model + ' uchun'} bordered size="small" column={1} style={{ marginBottom: '20px' }}>
                <Descriptions.Item label="Kategoriyasi">{vr.category}</Descriptions.Item>
                <Descriptions.Item label="Batafsil">{vr.descuz}</Descriptions.Item>
            </Descriptions>
            <div style={{marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h4>Variatsiyalari</h4>
                <Button icon={<PlusOutlined />} shape='circle' type='primary' onClick={() => {
                    setOpen(true)
                }} />
            </div>
           
          
           
           
            <Table bordered size="small" rowKey="id" columns={vcolumns} dataSource={variations} />
        </div>
    );
}

export default Variations;